import { Controller } from "stimulus";
import disableElement from "../../functions/disableElement.js";
import enableElement from "../../functions/enableElement.js";

// Disables every submitButton target until every input target holds non-blank text.
export default class extends Controller {
  static get targets() {
    return ["input", "submitButton"];
  }

  connect() {
    this.toggle();
  }

  toggle() {
    const filled = this.inputTargets.length > 0 &&
      this.inputTargets.every((input) => input.value.trim() !== "");

    this.submitButtonTargets.forEach((button) => {
      if (filled) {
        enableElement(button);
      } else {
        disableElement(button);
      }
    });
  }
}
